module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "converged-workbench"
  }, [_c('workbench-canvas', {
    attrs: {
      "copiedTarget": _vm.copiedTarget,
      "viewOnly": _vm.viewOnly
    },
    scopedSlots: _vm._u([{
      key: "main-container",
      fn: function(workbenchSlottedValue) {
        return [(_vm.noSelectedDatasetFamily) ? [_c('div', {
          staticClass: "text-h4 text-md-center",
          staticStyle: {
            "margin-top": "20vh"
          }
        }, [_c('p', [_vm._v("Graphs will be available when you select at least one attribute")])])] : (_vm.showInsights) ? [_c('insights', {
          attrs: {
            "workbenchSlottedValue": workbenchSlottedValue.slottedValue,
            "viewOnly": _vm.viewOnly
          }
        })] : (_vm.selectedLasDatasetFamily) ? [_c('las-graphs', {
          attrs: {
            "workbenchSlottedValue": workbenchSlottedValue.slottedValue
          }
        })] : _vm._e()]
      }
    }, {
      key: "bottom-pane",
      fn: function(bottomPane) {
        return [_c('bottom-panel', {
          attrs: {
            "targetData": bottomPane.copiedTarget,
            "viewOnly": _vm.viewOnly,
            "xandrActions": _vm.noSelectedDatasetFamily || _vm.showInsights,
            "lasActions": _vm.selectedLasDatasetFamily
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('save-workbench-changes-modal', {
    ref: "saveWorkbenchChangesModal",
    attrs: {
      "newXandrTarget": _vm.copiedTarget
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c29086a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/workbenchConvergence/WorkbenchConvergence.vue
// module id = 1958
// module chunks = 0